/* eslint-disable */
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RewardsAccountType, RewardsEntity } from "app/features/Categories/types/RewardsAccountType";
import {
    FiservStoredValueCardsEntity,
    PaymentCardsEntity,
    PersonalInfo,
    StoredValueCardsEntity,
    UserDetailResponseType
} from "app/features/Login/types/UserDetailResponseType";
import {IAddress, IPreferences} from 'app/features/MyAccount/types/SignUpForm';
import { FiservVaultedCard } from "app/features/LoyalityAddFunds/types/AddFundsRequest";
import { fetchGateAPI } from 'app/services/api/fetchGateApi';

const initialState: UserState = {
    firstName: '',
    lastName: '',
    email: '',
    phoneNumber: '',
    dateOfBirth: '',
    balancePoints: 0,
    balanceAmount: 0,
    storedValueCards: [],
    paymentCards: [],
    fdCustomerId: '',
    fiservCards: [],
    cardNumber:'00000000000000000000',
    cardLast4:'0000',
    rewards:[],
    appliedCoupon: '',
    couponErrorMessage: '',
    isFormInvalid: false,
    address: {
        city: '',
        state: '',
        zip: ''
    },
    smsCampaignOptIn: false,
    smsOptInVerified: false,
    preferences: {
        bruProgram: false,
        nnybCateringEmail: false,
        cateringEmail: false,
        ebbProgram: false,
        nnybProgram: false,
        bruCateringEmail: false,
        perksEmail: false,
        bruEmail: false,
        ebbEmail: false,
        perksProgram: false,
        nnybEmail: false,
    }
};

export interface UserState {
    firstName: string;
    lastName: string;
    phoneNumber?: string;
    email?: string;
    dateOfBirth?: string;
    balancePoints: number;
    balanceAmount: number;
    storedValueCards?: (StoredValueCardsEntity)[];
    paymentCards?: (PaymentCardsEntity)[];
    fdCustomerId?: string;
    fiservCards?: (FiservVaultedCard)[];
    cardNumber: string;
    cardLast4: string;
    rewards: (RewardsEntity)[];
    appliedCoupon: string;
    couponErrorMessage: string;
    isFormInvalid?: boolean;
    address: IAddress;
    preferences: IPreferences;
    smsCampaignOptIn: boolean,
    smsOptInVerified: boolean,
    fiservStoredValueCards?: (FiservStoredValueCardsEntity)[];
}


export const userSlice = createSlice({
    name: 'rewards',
    initialState,
    extraReducers: (builder) => {
        builder.addMatcher(fetchGateAPI.endpoints.getBalance.matchFulfilled, (state, action) => {
            const balanceData = action.payload as unknown as RewardsAccountType;
            state.balancePoints = balanceData.getBalanceResult.pointsBalance;
            state.balanceAmount = balanceData.getBalanceResult.balanceAmount;
            state.rewards = balanceData.getBalanceResult.rewards ? balanceData.getBalanceResult.rewards : [];
        });
    },
    reducers: {
        updateBalance: (state, action: PayloadAction<RewardsAccountType>) => {
            state.balancePoints = action.payload.getBalanceResult.pointsBalance;
            state.balanceAmount = action.payload.getBalanceResult.balanceAmount;
            state.rewards = action.payload.getBalanceResult.rewards ? action.payload.getBalanceResult.rewards : [];
        },
        updateUserDetail: (state, action: PayloadAction<UserDetailResponseType>) => {
            state.firstName = action.payload.getResult.personalInfo.firstName;
            state.lastName = action.payload.getResult.personalInfo.lastName;
            state.phoneNumber = action.payload.getResult.personalInfo.memberPhone;
            state.email = action.payload.getResult.personalInfo.emailAddress;
            state.dateOfBirth = action.payload.getResult.personalInfo.dateOfBirth;
            state.storedValueCards = (action.payload.getResult.billingInfo.storedValueCards) ? action.payload.getResult.billingInfo.storedValueCards : [];//Only first card considered  -- assumption
            state.paymentCards = (action.payload.getResult.billingInfo.paymentCards) ? action.payload.getResult.billingInfo.paymentCards : [];
            state.cardNumber = state?.paymentCards[0]?.cardNumberPartial;
            state.cardLast4 = state?.cardNumber?.slice(-4);
            state.address = action.payload.getResult.personalInfo.address || initialState.address;
            state.preferences = action.payload.getResult.preferences;
            state.fdCustomerId = action.payload.getResult.fiservCustomerId;
            state.fiservStoredValueCards = action.payload.getResult.billingInfo.fiservStoredValueCards || [];
            state.smsCampaignOptIn = action.payload.getResult.personalInfo.smsCampaignOptIn || false;
            state.smsOptInVerified = action.payload.getResult.personalInfo.smsOptInVerified || false;
        },
        updateFdCustomerId: (state, action: PayloadAction<string>) => {
            state.fdCustomerId = action.payload;
        },
        updateUserPersonalInfo: (state, action: PayloadAction<PersonalInfo>) => {
            state.firstName = action.payload.firstName;
            state.lastName = action.payload.lastName;
            state.phoneNumber = action.payload.memberPhone;
            state.email = action.payload.emailAddress;
        },
        updateFiservPaymentCards: (state, action: PayloadAction<FiservVaultedCard[]>) => {
            state.fiservCards = (action.payload);
            state.cardNumber = state.fiservCards[0]?.alias;
            state.cardLast4 = state.fiservCards[0]?.alias;
        },
        updateFiservStoredValueCards: (state, action: PayloadAction<FiservStoredValueCardsEntity[]>) => {
            state.fiservStoredValueCards = action.payload;
        },
        setFormValidation: (state, action: PayloadAction<boolean>) => {
            state.isFormInvalid = action.payload;
        },
        updateAppliedCoupon: (state,action:PayloadAction<string>) => {
            state.appliedCoupon = action.payload;
        },
        updateCouponErrorMsg: (state,action:PayloadAction<string>) => {
            state.couponErrorMessage = action.payload;
        },
        resetUserDetail: () => initialState,
    },
});

export default userSlice.reducer;

// export methods
export const {
    updateBalance,
    updateUserDetail,
    updateUserPersonalInfo,
    updateFiservPaymentCards,
    updateFiservStoredValueCards,
    resetUserDetail,
    setFormValidation,
    updateAppliedCoupon,
    updateCouponErrorMsg,
    updateFdCustomerId,
} = userSlice.actions;
